import MenuWithDrawer from "../../components/app/layout/menuWithDrawer/menuWithDrawer";
import ContentRouter from "../../routers/contentRouter.jsx";

/* MenuWithDrawer contains the app layout for authenticated routes. (app bar, side menu drawer)
 * This is a default layout that can be used for clients without any specific design in mind.
 * You can replace this layout with another one, depending on your new app design.
* */

const Content = () => {

	return (
		<MenuWithDrawer>
			<ContentRouter/>
		</MenuWithDrawer>

	)
}

export default Content;
